// extracted by mini-css-extract-plugin
export default {"container":"ApzDg","title-section":"du7Ay","body-section":"sQHsJ"};